import { For, Show, onCleanup } from 'solid-js';
import { useActiveBot } from '../state/activeBot';
import { clearFanOutResults, fanOutResults } from '../hooks/useBotFanOut';
import BotStatusBadge from './BotStatusBadge';
import DispatchResultPill from './DispatchResultPill';
import Text from './Text';
import { useTranslation } from '../hooks/useTranslation';
import styles from './GroupScopeBar.module.css';

interface GroupScopeBarProps {
    groupAware: boolean;
    scopeKey?: string;
    pageAligned?: boolean;
}

export default function GroupScopeBar(props: GroupScopeBarProps) {
    const { group, groupBots, botId, setFocus } = useActiveBot();
    const { t } = useTranslation();
    onCleanup(clearFanOutResults);

    return (
        <Show when={group()}>
            {(selectedGroup) => (
                <div class={`fcard ${styles.bar} ${props.pageAligned ? styles.pageAligned : ''}`}>
                    <div class={styles.heading}>
                        <i class="fa-solid fa-layer-group" />
                        <span class={styles.groupName}>{selectedGroup().name}</span>
                        <span class={styles.scope}>
                            <Show when={props.groupAware} fallback={<Text val="GROUP_SCOPE_SINGLE" />}>
                                {t(props.scopeKey ?? 'GROUP_SCOPE_ALL', String(groupBots().length))}
                            </Show>
                        </span>
                    </div>
                    <div class={styles.members}>
                        <For each={groupBots()}>{(member) => (
                            <button
                                type="button"
                                class={`${styles.member} ${member.id === botId() ? styles.memberFocused : ''}`}
                                onClick={() => setFocus(member.id)}
                            >
                                <img class={styles.avatar} src={`https://mc-heads.net/avatar/${member.minecraftUuid}/24`} alt="" />
                                <span class={styles.memberName}>{member.minecraftUsername}</span>
                                <BotStatusBadge state={member.state} compact />
                                <Show when={fanOutResults()[member.id]}>
                                    {(result) => <DispatchResultPill result={result()} />}
                                </Show>
                            </button>
                        )}</For>
                    </div>
                </div>
            )}
        </Show>
    );
}
